import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import http from './api/http.js'
import ports from './api/ports.js'


Vue.prototype.http = http
Vue.prototype.ports = ports

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
